/*
 * @Descripttion: 供应商订单发票录入页reducer
 * @Author: cb4786
 * @Date: 2023-08-21 11:13:46
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-28 10:28:22
 */
import { ActionType, CustomAction } from '../../../global'
export interface State {
  dataSource: { data: any[]; total: number }
  loading: boolean
  searchdata: any
  pages: {
    pageNo: number
    pageSize: number
  }
  selectedRows: any[]
  invoiceTip: boolean
}

export const initialState: State = {
  dataSource: { data: [], total: 100 },
  loading: true,
  searchdata: {},
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
  selectedRows: [],
  invoiceTip: false,
}

type Action = ActionType<State>

export const reducer = (state: State, action: CustomAction<Action>): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setSearchdataAction':
      // 搜索 重置 分页
      newstate.searchdata = action.payload
      newstate.pages.pageNo = 1
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setPagesAction':
      newstate.pages = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    case 'setInvoiceTipAction':
      newstate.invoiceTip = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

// 表格页面loading
export const setLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: val,
})

// 设置页面数据
export const setDataSourceAction = (param: {
  dataSource: { data: any[]; total: number }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 搜索参数
export const setSearchdataAction = (param: any): CustomAction<Action> => ({
  type: 'setSearchdataAction',
  payload: param,
})

// 分页修改
export const setPagesAction = (param: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPagesAction',
  payload: param,
})

// 选中数据
export const setSelectedRowsAction = (val: any): CustomAction<Action> => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

// 开票提示
export const setInvoiceTipAction = (val: boolean): CustomAction<Action> => ({
  type: 'setInvoiceTipAction',
  payload: val,
})
/*
 * @Descripttion: 供应商订单发票录入页reducer
 * @Author: cb4786
 * @Date: 2023-08-21 11:13:46
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-28 10:28:22
 */
import { ActionType, CustomAction } from '../../../global'
export interface State {
  dataSource: { data: any[]; total: number }
  loading: boolean
  searchdata: any
  pages: {
    pageNo: number
    pageSize: number
  }
  selectedRows: any[]
  invoiceTip: boolean
}

export const initialState: State = {
  dataSource: { data: [], total: 100 },
  loading: true,
  searchdata: {},
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
  selectedRows: [],
  invoiceTip: false,
}

type Action = ActionType<State>

export const reducer = (state: State, action: CustomAction<Action>): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setSearchdataAction':
      // 搜索 重置 分页
      newstate.searchdata = action.payload
      newstate.pages.pageNo = 1
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setPagesAction':
      newstate.pages = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    case 'setInvoiceTipAction':
      newstate.invoiceTip = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

// 表格页面loading
export const setLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: val,
})

// 设置页面数据
export const setDataSourceAction = (param: {
  dataSource: { data: any[]; total: number }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 搜索参数
export const setSearchdataAction = (param: any): CustomAction<Action> => ({
  type: 'setSearchdataAction',
  payload: param,
})

// 分页修改
export const setPagesAction = (param: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPagesAction',
  payload: param,
})

// 选中数据
export const setSelectedRowsAction = (val: any): CustomAction<Action> => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

// 开票提示
export const setInvoiceTipAction = (val: boolean): CustomAction<Action> => ({
  type: 'setInvoiceTipAction',
  payload: val,
})
